import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Stack } from '@mui/material';
import employeeActivityService from '../../service/employeeActivity.service';
import EmployeeActivityChip from './EmployeeActivityChip';
import { sxConfig } from './EmployeeActivity.style';

export const EmployeeActivityPage = () => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    employeeActivityService.getItems().then((data) => {
      setEmployees(data);
    });
  };

  const getUnifiedOperations = (employee) => {
    const baseOps =
      employee.productionOperation?.map((op) => ({
        ...op,
        isMultiResource: false,
      })) ?? [];

    const multiOps =
      employee.productionOperationMultiResource?.map((multi) => ({
        ...multi.productionOperation,
        isMultiResource: true,
        multiResourceId: multi.id,
      })) ?? [];

    return [...baseOps, ...multiOps];
  };

  return (
    <Box sx={sxConfig().tableContainerBox}>
      <TableContainer component={Paper}>
        <Table sx={sxConfig().table}>
          <TableHead>
            <TableRow>
              <TableCell sx={sxConfig().firstRowFirstTableCell}>Dolgozók</TableCell>
              <TableCell sx={sxConfig().firstRowSecondTableCell}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((employee, index) => (
              <TableRow key={index}>
                <TableCell sx={sxConfig().secondRowFirstTableCell}>{employee.name}</TableCell>
                <TableCell sx={sxConfig().firstRowSecondTableCell}>
                  <Box sx={sxConfig().scrollableBox} className="custom-scrollbar">
                    <Stack sx={sxConfig().stack}>
                      {getUnifiedOperations(employee).map((op) => (
                        <EmployeeActivityChip key={op.id} data={op} />
                      ))}
                    </Stack>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
